/* eslint-disable prettier/prettier */
import React, { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { ExclamationCircleOutlined, FilterOutlined } from '@ant-design/icons';
import { Switch, Table, Button, Checkbox, Select, Input, Tooltip, Modal, Collapse } from 'antd';
import {
  DownloadOutlined,
  DeleteOutlined,
  PlusOutlined,
  UploadOutlined,
  SearchOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { useAlert } from 'react-alert';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { FiPlus, FiSearch, FiEdit2 } from 'react-icons/fi';
import SuperAdminFields from './superAdminFields';
import { useHistory, useParams } from 'react-router';
import AdminAPIs from '../../../../api/admin';
import { set } from 'lodash-es';
import { readFile, utils } from 'xlsx';
import _ from 'lodash';
// import ExportReactCSV from '../../../../helpers/export';
import { CSVLink } from 'react-csv';
import { handleSuccessMessages, handleErrorMessages } from '../../../../helpers/flashMessages';

const SuperAdmin = () => {
  // const { sidebarContent, setRenderContent } = useContext(RenderContentContext);
  const history = useHistory();
  const [admins, setAdmins] = useState([]);
  const [table, setTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const alert = useAlert();
  const [typingTimeout, setTypingTimeout] = useState(0);
  const { Search } = Input;
  const [exportData, setExportData] = useState([]);
  const [collapse, setCollapse] = useState([]);
  const { id } = useParams();
  const { Option, OptGroup } = Select;
  const { Panel } = Collapse;
  const suffix = (
    <SearchOutlined
      style={{
        fontSize: 16,
        color: '#F0734F',
      }}
    />
  );
  const [options, setOptions] = useState({
    search: '',
    status: '',
    role: 'admin',
    pagination: { current: 1, pageSize: 10, pageSizeOptions: [10, 20, 50] },
    sortFilters: {},
    start: '',
    end: '',
  });
  const { confirm } = Modal;
  const columns = [
    {
      title: (
        <Checkbox
          onChange={e => onSelectAll(e)}
          checked={
            selectedRows.length > 0 &&
            _.isEqual(
              _.sortBy(admins.map(x => x._id)),
              _.sortBy(
                _.intersectionWith(
                  selectedRows,
                  admins.map(x => x._id),
                  _.isEqual
                )
              )
            )
          }
        />
      ),
      dataIndex: '_id',
      key: 'select',
      // eslint-disable-next-line react/display-name
      render: _id => <Checkbox onChange={e => onSelectRow(e, _id)} checked={selectedRows.includes(_id)} />,
    },

    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      sorter: true,
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      sorter: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: true,
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      key: 'mobile',
      // sorter: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: status => `${status ? 'Active' : 'Inactive'}`,
    },
    {
      title: 'Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: true,
      // defaultSortOrder: 'descend',
      // sortDirections: ['ascend'],
      render: createdAt => (createdAt ? moment(createdAt).format('MMMM Do YYYY') : 'NA'),
    },
    {
      title: 'Actions',
      dataIndex: '_id',
      // eslint-disable-next-line react/display-name
      render: _id => (
        <>
          <Link to={`/admin/edit/${_id}`} onClick={e => editOnClick(e, _id)}>
            <Tooltip placement="top" title="edit">
              <EditOutlined />
            </Tooltip>
          </Link>
          <Tooltip title="delete">
            <DeleteOutlined className="ml-2" onClick={e => showDeleteConfirm(e, _id)} />
          </Tooltip>
        </>
      ),
    },
  ];
  const onSwitchChange = async (checked, status, id) => {
    const data = { status: checked };
    setOptions({ ...options, status: checked });
    const response = await AdminAPIs.updateAdmin(id, data);
    setTimeout(()=>{
      getUserList(options);
    },1000)
  };
  const getAdmin = id => {
    (async () => {
      try {
        const response = await AdminAPIs.getAdmin(id);
        const { id } = response.data.admin.id;
        return id;
      } catch (e) {
        console.log(e);
      }
    })();
  };
  const ID = localStorage.getItem('LoginId');
  const showDeleteConfirm = (e, _id) => {
    // getAdmin();
    confirm({
      title: 'Are you sure?',
      icon: <ExclamationCircleOutlined />,
      content: 'The deleted record will not be recovered.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',

      onOk() {
        if (_id != ID) {
          const response = AdminAPIs.deleteUser(_id);
          handleSuccessMessages({customMessage: `Admin deleted successfully.`}, alert);
        } else if(_id == ID) {
          handleErrorMessages({ customMessage: `Logged in user can not be deleted.` }, alert);
        }
        setTimeout(()=>{
          getUserList(options);
        },1000)
   
        setSelectedRows([]);
      },

      onCancel() {
        setSelectedRows([]);
      },
    });
  };

  const showDelete = (e, selectedRows) => {
    confirm({
      title: 'Are you sure?',
      icon: <ExclamationCircleOutlined />,
      content: 'The deleted record will not be recovered.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',

      onOk() {
        if (!selectedRows.includes(ID)) {
        const response = AdminAPIs.deleteMultipleUsers([selectedRows]);
        handleSuccessMessages({customMessage: `Admin deleted successfully.`}, alert);
        } else if (selectedRows.includes(ID)) {
          const newIDs = selectedRows.filter(item => item !== ID)
          const response = AdminAPIs.deleteMultipleUsers([newIDs]);
          handleErrorMessages({customMessage: `Logged in Admin can not be deleted.`}, alert);   
        }
        setTimeout(()=>{
          getUserList(options);
        },1000)
        setSelectedRows([]);
      },

      onCancel() {
        setSelectedRows([]);
      },
    });
  };

  const [dataState, setDataState] = useState([]);
  const handleFile = async e => {
    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = readFile(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsondata = utils.sheet_to_json(worksheet);
    setDataState(
      jsondata.map((e, i) => ({
        role: e.role,
        firstName: e.firstName,
        lastName: e.lastName,
        email: e.email,
        mobile: e.mobile,
      }))
    );
    setTable(
      jsondata.map((e, i) => ({
        role: e.role,
        firstName: e.firstName,
        lastName: e.lastName,
        email: e.email,
        mobile: e.mobile,
        createdAt: e.createdAt,
      }))
    );
  };
  const editOnClick = (e, user) => {};
  const onSearch = value => console.log(value);
  function handleChange(value) {}

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const onChangedate = dates => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setOptions({
      ...options,
      start: moment(start).format('YYYY-MM-DD'),
      end: moment(end).format('YYYY-MM-DD'),
    });
  };

  const getUserList = async options => {
    try {
      setLoading(true);
      const response = await AdminAPIs.getAllAdmin(options);
      const { admins } = response.data;
      setAdmins(response.data.admins.docs);
      setOptions({
        ...options,
        pagination: {
          current: admins.page,
          pageSize: admins.limit,
          total: admins.totalDocs,
          showSizeChanger: true,
        },
      });
    } catch (e) {
      setLoading(false);
      console.error('e');
    }
    setLoading(false);
  };

  const getAllAdmins = async options => {
    try {
      setLoading(true);
      const response = await AdminAPIs.getAllUsers(options);
      // const { users } = response.data;
      // setExportData(users);
      let finaldata = response.data.users || [] 
      finaldata.map((data)=>{
      ['_id','password','profilePic','customerId','isDeleted','__v','customers'].map(item=>delete data[item])
      data.createdAt=moment(data.createdAt).format('DD-MM-yyyy')
     })
      setExportData(finaldata);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
    setLoading(false);
  };

  // const handleExport = () => {
  //   getAllAdmins(options);
  // };
  const handleExport = async options => {
    try {
      setLoading(true);
      options.role='admin'
      const response = await AdminAPIs.getAllUsers(options);
      if(response.data.users.length >0)
       {
        let finaldata = response.data.users || [];
        let updateData = [];
        finaldata.forEach((el) => {
          const { user,province,postalCode,city} = el;
          updateData.push({
           FirstName: user.firstName,
           LastName: user.lastName,
           CityProvince: `${city} ${province ? `/${province}` :''}`,
           PostalCode: postalCode,
           Role:user.role
         });
        });
        setExportData(updateData);
    
      document.getElementById('csvLink').click();
       }
    } catch (e) {
      setLoading(false);
      console.error('e');
    }
    setLoading(false);
  };

  const handleFilterClick = () => {
    setCollapse([]);
    getUserList({ ...options, pagination: { ...options.pagination, current: 1 } });
    getAllAdmins(options);
  };
  const handleClearAllClick = () => {
    setCollapse([]);
    const updatedOptions = {
      ...options,
      status: '',
      role: '',
      pagination: { ...options.pagination, current: 1 },
      start: '',
      end: '',
    };
    setEndDate(null);
    setStartDate(null);
    setOptions(updatedOptions);
    getUserList(updatedOptions);
    getAllAdmins(updatedOptions);
  };

  useEffect(() => {
    getUserList(options);
    // getAllAdmins(options);
  }, []);

  function onChange(pagination, filters, sorter, extra) {
    // const {current, pageSize} = pagination;
    // const updatedOptions = { ...options, current, pageSize };
    const updatedOptions = { ...options, pagination };
    setOptions(updatedOptions);
    getUserList({
      ...updatedOptions,
      sortFilters: {
        sortField: sorter?.columnKey,
        sortOrder: sorter?.order,
      },
    });
  }

  const onSelectAll = e => {
    if (e.target.checked) {
      const test = [...new Set([...selectedRows, admins.map(n => n._id)].flat())];
      setSelectedRows(test);
    } else {
      const selectedIds = selectedRows.filter(n => !admins.map(x => x._id).includes(n));
      setSelectedRows(selectedIds);
    }
  };
  const collapseShowHideFunc = key => {
    setCollapse(key);
  };
  const onSelectRow = async (e, _id) => {
    if (e.target.checked) {
      setSelectedRows([...selectedRows, _id]);
    } else {
      const selectedIds = selectedRows.filter(n => n !== _id);
      setSelectedRows(selectedIds);
    }
  };

  const filterSortedTable = e => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const query = e.target.value;
    const updatedOptions = {
      ...options,
      search: query.trim(),
      pagination: { ...options.pagination, current: 1 },
    };
    setOptions(updatedOptions);
    setTypingTimeout(() =>
      setTimeout(() => {
        getUserList(updatedOptions);
      }, 1000)
    );
  };
  return (
    <>
      {/* <Helmet>
        <script
          src="https://cdn.jsdelivr.net/gh/alpinejs/alpine@v2.x.x/dist/alpine.min.js"
          type="text/javascript"
        />
        <script src="http://localhost:3000/js/init-alpine.js" type="text/javascript" />
      </Helmet> */}
      <div className="filter--outer mb-4">
        <div className="d-flex top--heading1">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-200">Admin</h2>
          <div className="right--btn">
            <button className="bg-primary hover:bg-opacity-80 py-2 px-4 text-white rounded-sm ">
              <Link to="/admin/add">
                <FiPlus className="inline-block align-middle mr-2 text-base" />
                <p className="inline-block align-middle">Add Admin</p>
              </Link>
            </button>
          </div>
        </div>
        <div className="d-flex filter--wrap my-5">
          <div className="d-flex mb-0 mb-sm-0 gap-2 ">
            <div className="del--icon" style={selectedRows.length === 0 ? { cursor: 'default' } : {}}>
              <DeleteOutlined
                onClick={e => (selectedRows.length === 0 ? {} : showDelete(e, selectedRows))}
                style={selectedRows.length === 0 ? { cursor: 'default' } : {}}
              />
            </div>
            <div className="filter_content w-100 d-flex">
              <Collapse activeKey={collapse} onChange={collapseShowHideFunc}>
                <Panel
                  showArrow={false}
                  header={
                    <React.Fragment>
                      <FilterOutlined className="mr-2" style={{ marginBottom: '1px' }} />
                      <span className="anticon anticon-filter">Filters</span>
                    </React.Fragment>
                  }
                  key="1"
                  className="site-collapse-custom-panel"
                >
                  <div className="card card-body">
                    <div className="row">
                      <div className="col-12 filter_header d-flex flex-wrap position-relative">
                        <h4 className="title">Filter By</h4>
                        <button className="clearfilter_btn btn-default" onClick={handleClearAllClick}>
                          Clear all
                        </button>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4 col-xl-2 fltr_cell">
                        <label className="label">Status</label>
                        <Select
                          className="text-1 font-normal rounded-r-none active-inactive-filter"
                          name="status"
                          defaultValue="all"
                          value={options.status}
                          onChange={e => setOptions({ ...options, status: e })}
                        >
                          <Option value="">All</Option>
                          <Option value={true}>Active</Option>
                          <Option value={false}>Inactive</Option>
                        </Select>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4 col-xl-3 fltr_cell">
                        <label className="label">Date</label>
                        {/* <label> */}
                        <DatePicker
                          className="date-picker"
                          selected={startDate}
                          onChange={onChangedate}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange={true}
                          withPortal
                          placeholderText="MM/DD/YYYY"
                          isClearable={false}
                          maxDate={new Date()}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                        />
                        {/* </label> */}
                      </div>
                      <div className="col-12 col-md-6 col-lg-4 col-xl-2 fltr_cell d-flex justify-content-end">
                        <label className="label"></label>
                        <button
                          type="button"
                          className="bg-primary hover:bg-opacity-80 py-2 px-4 text-white rounded-sm"
                          onClick={handleFilterClick}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div>
          </div>
          {/* <Select defaultValue="lucy" style={{ width: 200 }} onChange= {handleChange}>
              <OptGroup label="Manager">
                <Option value="jack">Jack</Option>
                <Option value="lucy">Lucy</Option>
              </OptGroup>
              <OptGroup label="Engineer">
                <Option value="Yiminghe">yiminghe</Option>
              </OptGroup>
            </Select> */}

          <div className="d-flex flex-wrap gap-2">
            <label className="custom-field ">
              <input type="file" name="file" onChange={e => handleFile(e)} />
              <span className="placeholder ant-btn ant-btn-primary">
                <DownloadOutlined /> Import
              </span>
            </label>
            {/* <ExportReactCSV csvData={exportData} fileName={'Admins.csv'} handleSubmit={handleExport} /> */}
            <Button className="mr-2 placeholder ant-btn ant-btn-primary" type="primary" icon={<UploadOutlined className='mr-1' />} onClick={() => handleExport(options)}>
              Export 
            </Button>
            <CSVLink
              id="csvLink"
              data={exportData}
              filename={'Admin.csv'}
              style={{ display: 'none' }}
            >
              Export 
            </CSVLink>
            <Search
              className="input-search-box search--wrap mt-3 mt-sm-0"
              placeholder="input search text"
              // enterButton="Search"
              size="large"
              // addonBefore={suffix}
              onChange={e => filterSortedTable(e)}
            />
          </div>
        </div>
      </div>
      <main className="overflow-y-auto main--table">
        <div className="grid mx-auto">
          <div className="w-full mb-8 overflow-hidden shadow-xs">
            <div className="w-full overflow-x-auto">
              <Table
                dataSource={dataState.length > 0 ? table : admins}
                columns={columns}
                rowKey={record => record._id}
                onChange={onChange}
                pagination={options.pagination.total > 10 ? options.pagination : false}
                sortDirections={['ascend', 'descend']}
                loading={loading}
                scroll={{ scrollToFirstRowOnChange: true }}
              />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
export default SuperAdmin;
